import { createSlice } from "@reduxjs/toolkit";
import {
  getSystemData,
  addUser,
  addTrainingUser,
  editTrainingUser,
  getUsers,
  editUser,
  disableUser,
  enableUser,
  getClients,
  addClient,
  editClient,
  disableClient,
  enableClient,
  getRoles,
  getProducts,
  editProduct,
  deleteProduct,
  enableProduct,
  addProduct,
  getPrograms,
  getPlans,
  getClientPlan,
  getClientType,
  getAllClientSalesmen,
  deactivateSalesRep,
  activateSalesRep,
  attachProduct,
  getAllClientMarketingCost,
  updateClientMarketingCost,
  getClientAdmin,
  updateClientAdminNotification,
  updateClientNotification,
  getClientUserTitle,
  sendEmailNotification,
} from "../../thunks/systemManagementThunk";
import { PURGE } from "redux-persist";

interface SystemManagementState {
  systemLoading: Boolean;
  getUserLoading: Boolean;
  getClientsLoading: Boolean;
  getRolesLoading: Boolean;
  getProductsLoading: Boolean;
  getProgramsLoading: Boolean;
  getPlansLoading: Boolean;
  getClientPlanLoading: Boolean;
  getClientTypeLoading: Boolean;
  addUserLoading: Boolean;
  addTrainingUserLoading: Boolean;
  editTrainingUserLoading: Boolean;
  addClientLoading: Boolean;
  addProductLoading: Boolean;
  getAllClientSalesmenLoading: Boolean;
  deactivateSalesRepLoading: Boolean;
  activateSalesRepLoading: Boolean;
  updateUserTabe?: Boolean;
  attachProductLoading: Boolean;
  getAllClientMarketingCostLoading: Boolean;
  updateClientMarketingCostLoading: Boolean;
  getClientAdminLoading: Boolean;
  updateClientAdminNotificationLoading: Boolean;
  updateClientNotificationLoading: Boolean;
  getClientUserTitleLoading: Boolean;
  sendEmailNotificationLoading: Boolean;
  error: any;
  response: any;
  success: Boolean;

  activeSubscriber?: any;
  analyticSalesRep?: any;
  emailReports?: any;
  allUsers?: any;
  allClients?: any;
  clientPlan?: any;
  clientType?: any;
  allPlans?: any;
  allProducts?: any;
  allPrograms?: any;
  allRoles?: any;
  allSalesMen?: any;
  allClientSalesMen?: any;
  paymentIntent?: any;
  publishableKey?: any;
  allClientMarketingCost?: any;
  clientAdmin?: any;
  clientUserTitle?: any;
}

const initialState: SystemManagementState = {
  systemLoading: false,
  getUserLoading: false,
  getClientsLoading: false,
  getRolesLoading: false,
  getProductsLoading: false,
  getProgramsLoading: false,
  getPlansLoading: false,
  getClientPlanLoading: false,
  getClientTypeLoading: false,
  addUserLoading: false,
  addTrainingUserLoading: false,
  editTrainingUserLoading: false,
  addClientLoading: false,
  addProductLoading: false,
  getAllClientSalesmenLoading: false,
  deactivateSalesRepLoading: false,
  activateSalesRepLoading: false,
  attachProductLoading: false,
  getAllClientMarketingCostLoading: false,
  updateClientMarketingCostLoading: false,
  getClientAdminLoading: false,
  updateClientAdminNotificationLoading: false,
  updateClientNotificationLoading: false,
  getClientUserTitleLoading: false,
  sendEmailNotificationLoading: false,
  error: null,
  response: null,
  success: false,

  activeSubscriber: null,
  analyticSalesRep: null,
  emailReports: null,
  allUsers: null,
  allClients: null,
  clientPlan: null,
  clientType: null,
  allPlans: null,
  allProducts: null,
  allPrograms: null,
  allRoles: null,
  allSalesMen: null,
  allClientSalesMen: null,
  publishableKey: null,
  allClientMarketingCost: null,
  clientAdmin: null,
  clientUserTitle: null,
};

export const systemManagementSlice = createSlice({
  name: "systemManagement",
  initialState,
  reducers: {
    systemManagementReset: (state) => {
      state.allUsers = null;
      state.activeSubscriber = null;
      state.analyticSalesRep = null;
      state.emailReports = null;
      state.allClients = null;
      state.clientPlan = null;
      state.clientType = null;
      state.allPlans = null;
      state.allProducts = null;
      state.allPrograms = null;
      state.allRoles = null;
      state.allSalesMen = null;
      state.systemLoading = false;
      state.error = null;
      state.response = null;
      state.allClientSalesMen = null;
      state.paymentIntent = null;
      state.publishableKey = null;
      state.allClientMarketingCost = null;
      state.clientAdmin = null;
      state.clientUserTitle = null;
      state.getUserLoading = false;
      state.getClientsLoading = false;
      state.getRolesLoading = false;
      state.getProductsLoading = false;
      state.getProgramsLoading = false;
      state.getPlansLoading = false;
      state.getClientPlanLoading = false;
      state.getClientTypeLoading = false;
      state.addUserLoading = false;
      state.addTrainingUserLoading = false;
      state.editTrainingUserLoading = false;
      state.addClientLoading = false;
      state.addProductLoading = false;
      state.getAllClientSalesmenLoading = false;
      state.deactivateSalesRepLoading = false;
      state.activateSalesRepLoading = false;
      state.attachProductLoading = false;
      state.getAllClientMarketingCostLoading = false;
      state.updateClientMarketingCostLoading = false;
      state.getClientAdminLoading = false;
      state.updateClientAdminNotificationLoading = false;
      state.updateClientNotificationLoading = false;
      state.getClientUserTitleLoading = false;
      state.sendEmailNotificationLoading = false;
    },
  },
  extraReducers(builder) {
    builder.addCase(PURGE, () => { return initialState; });
    builder.addCase(getSystemData.pending, (state) => {
      state.systemLoading = true;
      state.error = null;
    });
    builder.addCase(getSystemData.fulfilled, (state, action) => {
      state.activeSubscriber = action.payload.active_subscriber;
      state.analyticSalesRep = action.payload.all_analytic_sale_rep;
      state.allSalesMen = action.payload.sales_men_list;
      state.systemLoading = false;
    });
    builder.addCase(getSystemData.rejected, (state, action) => {
      state.systemLoading = false;
      state.error = action.payload;
    });

    // Get users
    builder.addCase(getUsers.pending, (state) => {
      state.getUserLoading = true;
      state.error = null;
    });
    builder.addCase(getUsers.fulfilled, (state, action) => {
      state.allUsers = action.payload.all_users;
      state.getUserLoading = false;
    });
    builder.addCase(getUsers.rejected, (state, action) => {
      state.getUserLoading = false;
      state.error = action.payload;
    });

    // Add user
    builder.addCase(addUser.pending, (state) => {
      state.addUserLoading = true;
      state.error = null;
    });
    builder.addCase(addUser.fulfilled, (state, action) => {
      state.response = action.payload;
      state.addUserLoading = false;
    });
    builder.addCase(addUser.rejected, (state, action) => {
      state.addUserLoading = false;
      state.error = action.payload;
    });

    // Add traininguser
    builder.addCase(addTrainingUser.pending, (state) => {
      state.addTrainingUserLoading = true;
      state.error = null;
    });
    builder.addCase(addTrainingUser.fulfilled, (state, action) => {
      state.response = action.payload;
      state.addTrainingUserLoading = false;
    });
    builder.addCase(addTrainingUser.rejected, (state, action) => {
      state.addTrainingUserLoading = false;
      state.error = action.payload;
    });

    //Edit traininguser
    builder.addCase(editTrainingUser.pending, (state) => {
      state.editTrainingUserLoading = true;
      state.error = null;
    });
    builder.addCase(editTrainingUser.fulfilled, (state, action) => {
      state.response = action.payload;
      state.editTrainingUserLoading = false;
    });
    builder.addCase(editTrainingUser.rejected, (state, action) => {
      state.editTrainingUserLoading = false;
      state.error = action.payload;
    });

    // Edit user
    builder.addCase(editUser.pending, (state) => {
      state.addUserLoading = true;
      state.error = null;
    });
    builder.addCase(editUser.fulfilled, (state, action) => {
      state.response = action.payload;
      state.addUserLoading = false;
    });
    builder.addCase(editUser.rejected, (state, action) => {
      state.addUserLoading = false;
      state.error = action.payload;
    });

    // Disable user
    builder.addCase(disableUser.pending, (state) => {
      state.addUserLoading = true;
      state.error = null;
    });
    builder.addCase(disableUser.fulfilled, (state, action) => {
      state.response = action.payload;
      state.addUserLoading = false;
    });
    builder.addCase(disableUser.rejected, (state, action) => {
      state.addUserLoading = false;
      state.error = action.payload;
    });

    // Enable user
    builder.addCase(enableUser.pending, (state) => {
      state.addUserLoading = true;
      state.error = null;
    });
    builder.addCase(enableUser.fulfilled, (state, action) => {
      state.response = action.payload;
      state.addUserLoading = false;
    });
    builder.addCase(enableUser.rejected, (state, action) => {
      state.addUserLoading = false;
      state.error = action.payload;
    });

    // Get clients
    builder.addCase(getClients.pending, (state) => {
      state.getClientsLoading = true;
      state.error = null;
    });
    builder.addCase(getClients.fulfilled, (state, action) => {
      state.allClients = action.payload.clients;
      state.getClientsLoading = false;
    });
    builder.addCase(getClients.rejected, (state, action) => {
      state.getClientsLoading = false;
      state.error = action.payload;
    });

    // Add client
    builder.addCase(addClient.pending, (state) => {
      state.addClientLoading = true;
      state.error = null;
    });
    builder.addCase(addClient.fulfilled, (state, action) => {
      state.response = action.payload;
      state.addClientLoading = false;
    });
    builder.addCase(addClient.rejected, (state, action) => {
      state.addClientLoading = false;
      state.error = action.payload;
    });

    // Edit client
    builder.addCase(editClient.pending, (state) => {
      state.addClientLoading = true;
      state.error = null;
    });
    builder.addCase(editClient.fulfilled, (state, action) => {
      state.response = action.payload;
      state.addClientLoading = false;
    });
    builder.addCase(editClient.rejected, (state, action) => {
      state.addClientLoading = false;
      state.error = action.payload;
    });

    // Disable client
    builder.addCase(disableClient.pending, (state) => {
      state.addClientLoading = true;
      state.error = null;
    });
    builder.addCase(disableClient.fulfilled, (state, action) => {
      state.response = action.payload;
      state.addClientLoading = false;
    });
    builder.addCase(disableClient.rejected, (state, action) => {
      state.addClientLoading = false;
      state.error = action.payload;
    });

    // Enable client
    builder.addCase(enableClient.pending, (state) => {
      state.addClientLoading = true;
      state.error = null;
    });
    builder.addCase(enableClient.fulfilled, (state, action) => {
      state.response = action.payload;
      state.addClientLoading = false;
    });
    builder.addCase(enableClient.rejected, (state, action) => {
      state.addClientLoading = false;
      state.error = action.payload;
    });

    // Get roles
    builder.addCase(getRoles.pending, (state) => {
      state.getRolesLoading = true;
      state.error = null;
    });
    builder.addCase(getRoles.fulfilled, (state, action) => {
      state.allRoles = action.payload.roles;
      state.getRolesLoading = false;
    });
    builder.addCase(getRoles.rejected, (state, action) => {
      state.getRolesLoading = false;
      state.error = action.payload;
    });

    // Get products
    builder.addCase(getProducts.pending, (state) => {
      state.getProductsLoading = true;
      state.error = null;
    });
    builder.addCase(getProducts.fulfilled, (state, action) => {
      state.allProducts = action.payload.products;
      state.getProductsLoading = false;
    });
    builder.addCase(getProducts.rejected, (state, action) => {
      state.getProductsLoading = false;
      state.error = action.payload;
    });

    builder.addCase(addProduct.pending, (state) => {
      state.addProductLoading = true;
      state.error = null;
    });
    builder.addCase(addProduct.fulfilled, (state, action) => {
      state.response = action.payload;
      state.addProductLoading = false;
    });
    builder.addCase(addProduct.rejected, (state, action) => {
      state.addProductLoading = false;
      state.error = action.payload;
    });

    // Edit product
    builder.addCase(editProduct.pending, (state) => {
      state.addProductLoading = true;
      state.error = null;
    });
    builder.addCase(editProduct.fulfilled, (state, action) => {
      state.response = action.payload;
      state.addProductLoading = false;
    });
    builder.addCase(editProduct.rejected, (state, action) => {
      state.addProductLoading = false;
      state.error = action.payload;
    });

    builder.addCase(deleteProduct.pending, (state) => {
      state.addProductLoading = true;
      state.error = null;
    });
    builder.addCase(deleteProduct.fulfilled, (state, action) => {
      state.response = action.payload;
      state.addProductLoading = false;
    });
    builder.addCase(deleteProduct.rejected, (state, action) => {
      state.addProductLoading = false;
      state.error = action.payload;
    });

    // Enable product
    builder.addCase(enableProduct.pending, (state) => {
      state.addProductLoading = true;
      state.error = null;
    });
    builder.addCase(enableProduct.fulfilled, (state, action) => {
      state.response = action.payload;
      state.addProductLoading = false;
    });
    builder.addCase(enableProduct.rejected, (state, action) => {
      state.addProductLoading = false;
      state.error = action.payload;
    });

    // Get programs
    builder.addCase(getPrograms.pending, (state) => {
      state.getProgramsLoading = true;
      state.error = null;
    });
    builder.addCase(getPrograms.fulfilled, (state, action) => {
      state.allPrograms = action.payload.programs;
      state.getProgramsLoading = false;
    });
    builder.addCase(getPrograms.rejected, (state, action) => {
      state.getProgramsLoading = false;
      state.error = action.payload;
    });

    builder.addCase(getPlans.pending, (state) => {
      state.getPlansLoading = true;
      state.error = null;
    });
    builder.addCase(getPlans.fulfilled, (state, action) => {
      state.allPlans = action.payload.plans;
      state.getPlansLoading = false;
    });
    builder.addCase(getPlans.rejected, (state, action) => {
      state.getPlansLoading = false;
      state.error = action.payload;
    });

    // Get client plan
    builder.addCase(getClientPlan.pending, (state) => {
      state.getClientPlanLoading = true;
      state.error = null;
    });
    builder.addCase(getClientPlan.fulfilled, (state, action) => {
      state.clientPlan = action.payload.client_plan;
      state.getClientPlanLoading = false;
    });
    builder.addCase(getClientPlan.rejected, (state, action) => {
      state.getClientPlanLoading = false;
      state.error = action.payload;
    });

    // Get client type
    builder.addCase(getClientType.pending, (state) => {
      state.getClientTypeLoading = true;
      state.error = null;
    });
    builder.addCase(getClientType.fulfilled, (state, action) => {
      state.clientType = action.payload.client_type;
      state.getClientTypeLoading = false;
    });
    builder.addCase(getClientType.rejected, (state, action) => {
      state.getClientTypeLoading = false;
      state.error = action.payload;
    });

    builder.addCase(getAllClientSalesmen.pending, (state) => {
      state.getAllClientSalesmenLoading = true;
      state.error = null;
    });
    builder.addCase(getAllClientSalesmen.fulfilled, (state, action) => {
      state.allClientSalesMen = action.payload.salesmen_view_list;
      state.getAllClientSalesmenLoading = false;
    });
    builder.addCase(getAllClientSalesmen.rejected, (state, action) => {
      state.getAllClientSalesmenLoading = false;
      state.error = action.payload;
    });

    // Deactivate sales rep
    builder.addCase(deactivateSalesRep.pending, (state) => {
      state.deactivateSalesRepLoading = true;
      state.error = null;
    });
    builder.addCase(deactivateSalesRep.fulfilled, (state, action) => {
      state.response = action.payload;
      state.deactivateSalesRepLoading = false;
    });
    builder.addCase(deactivateSalesRep.rejected, (state, action) => {
      state.deactivateSalesRepLoading = false;
      state.error = action.payload;
    });

    // Activate sales rep
    builder.addCase(activateSalesRep.pending, (state) => {
      state.activateSalesRepLoading = true;
      state.error = null;
    });
    builder.addCase(activateSalesRep.fulfilled, (state, action) => {
      state.response = action.payload;
      state.activateSalesRepLoading = false;
    });
    builder.addCase(activateSalesRep.rejected, (state, action) => {
      state.activateSalesRepLoading = false;
      state.error = action.payload;
    });

    // Attach product
    builder.addCase(attachProduct.pending, (state) => {
      state.attachProductLoading = true;
      state.error = null;
    });
    builder.addCase(attachProduct.fulfilled, (state, action) => {
      state.response = action.payload;
      state.attachProductLoading = false;
    });
    builder.addCase(attachProduct.rejected, (state, action) => {
      state.attachProductLoading = false;
      state.error = action.payload;
    });

    // Payment intent

    // Cancel payment intent

    // Payment config
    // Get all client marketing cost
    builder.addCase(getAllClientMarketingCost.pending, (state) => {
      state.getAllClientMarketingCostLoading = true;
      state.error = null;
    });
    builder.addCase(getAllClientMarketingCost.fulfilled, (state, action) => {
      state.allClientMarketingCost = action.payload.all_marketing_cost_result;
      state.getAllClientMarketingCostLoading = false;
    });
    builder.addCase(getAllClientMarketingCost.rejected, (state, action) => {
      state.getAllClientMarketingCostLoading = false;
      state.error = action.payload;
    });

    // Update client marketing cost
    builder.addCase(updateClientMarketingCost.pending, (state) => {
      state.updateClientMarketingCostLoading = true;
      state.error = null;
    });
    builder.addCase(updateClientMarketingCost.fulfilled, (state, action) => {
      state.response = action.payload;
      state.updateClientMarketingCostLoading = false;
    });
    builder.addCase(updateClientMarketingCost.rejected, (state, action) => {
      state.updateClientMarketingCostLoading = false;
      state.error = action.payload;
    });

    // Get client admin
    builder.addCase(getClientAdmin.pending, (state) => {
      state.getClientAdminLoading = true;
      state.error = null;
    });
    builder.addCase(getClientAdmin.fulfilled, (state, action) => {
      state.clientAdmin = action.payload.client_admin;
      state.getClientAdminLoading = false;
    });
    builder.addCase(getClientAdmin.rejected, (state, action) => {
      state.getClientAdminLoading = false;
      state.error = action.payload;
    });

    // Update client admin notification
    builder.addCase(updateClientAdminNotification.pending, (state) => {
      state.updateClientAdminNotificationLoading = true;
      state.error = null;
    });
    builder.addCase(
      updateClientAdminNotification.fulfilled,
      (state, action) => {
        state.response = action.payload;
        state.updateClientAdminNotificationLoading = false;
      }
    );
    builder.addCase(updateClientAdminNotification.rejected, (state, action) => {
      state.updateClientAdminNotificationLoading = false;
      state.error = action.payload;
    });

    // Update client notification
    builder.addCase(updateClientNotification.pending, (state) => {
      state.updateClientNotificationLoading = true;
      state.error = null;
    });
    builder.addCase(updateClientNotification.fulfilled, (state, action) => {
      state.response = action.payload;
      state.updateClientNotificationLoading = false;
    });
    builder.addCase(updateClientNotification.rejected, (state, action) => {
      state.updateClientNotificationLoading = false;
      state.error = action.payload;
    });

    // Get client user title
    builder.addCase(getClientUserTitle.pending, (state) => {
      state.getClientUserTitleLoading = true;
      state.error = null;
    });
    builder.addCase(getClientUserTitle.fulfilled, (state, action) => {
      state.clientUserTitle = action.payload.client_user_title;
      state.getClientUserTitleLoading = false;
    });
    builder.addCase(getClientUserTitle.rejected, (state, action) => {
      state.getClientUserTitleLoading = false;
      state.error = action.payload;
    });

    // Send email notification
    builder.addCase(sendEmailNotification.pending, (state) => {
      state.sendEmailNotificationLoading = true;
      state.error = null;
    });
    builder.addCase(sendEmailNotification.fulfilled, (state, action) => {
      state.response = action.payload;
      state.sendEmailNotificationLoading = false;
    });
    builder.addCase(sendEmailNotification.rejected, (state, action) => {
      state.sendEmailNotificationLoading = false;
      state.error = action.payload;
    });
  },
});

export const { systemManagementReset } = systemManagementSlice.actions;

export const systemManagementReducer = systemManagementSlice.reducer;
